import { render, staticRenderFns } from "./InternalPeopleForm.vue?vue&type=template&id=725714f2"
import script from "./InternalPeopleForm.vue?vue&type=script&lang=js"
export * from "./InternalPeopleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports